"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
/**
 * Local Imports
 */

const NavContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NavContainer",
  class: "pl-n1vxyf3e",
  vars: {
    "n1vxyf3e-2": [({
      disableSticky
    }) => disableSticky ? 'static' : 'sticky'],
    "n1vxyf3e-3": [({
      skipOffsetForNav
    }) => skipOffsetForNav ? 0 : '3.25rem'],
    "n1vxyf3e-6": [({
      skipOffsetForNav
    }) => skipOffsetForNav ? 0 : '3.75rem']
  }
});
const NavItems = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "NavItems",
  class: "pl-n130qgzi"
});
const Item = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "Item",
  class: "pl-irv1mib"
});
const Button = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "Button",
  class: "pl-b1f4txp5"
});

/**
 * Navigation item.
 *
 * @param {Object} props React props
 * @param {String} props._name Item Tracking Name
 * @param {Func} props.handleClick Button Click Event Handler
 * @param {Boolean} props.active Active Nav Item
 * @param {Boolean} props.text Nav Item Text
 * @returns {React.ReactElement} component
 * @public
 */
function NavigationItem({
  _name,
  handleClick,
  active,
  text: textProp
}) {
  if (!textProp) return null;
  return /*#__PURE__*/_react.default.createElement(Item, {
    role: "listitem"
  }, /*#__PURE__*/_react.default.createElement(Button, (0, _extends2.default)({
    "data-active": active,
    onClick: handleClick
  }, _patternLibraryUtils.tracking.create(_name, true, false)), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    text: textProp
  })));
}
NavigationItem.propTypes = {
  _name: _propTypes.default.string,
  handleClick: _propTypes.default.func,
  active: _propTypes.default.bool,
  text: _propTypes.default.string
};

/**
 * Navigation Component.
 *
 * @param {Object} props React props
 * @param {Array} props.items Elements to Filter
 * @param {Funtion} props.setFilter Setter
 * @param {Boolean} props.disableSticky disables sticky header
 * @param {Boolean} props.skipOffsetForNav removes offset for sticky header
 * @param {String|Number} props.toggleState navigation active state
 * @returns {React.ReactElement} Navigation Component
 * @public
 */

function Navigation({
  items,
  setFilter,
  disableSticky,
  skipOffsetForNav,
  toggleState
}) {
  if (items?.length <= 1) return null;
  return /*#__PURE__*/_react.default.createElement(NavContainer, {
    disableSticky: disableSticky,
    skipOffsetForNav: skipOffsetForNav,
    role: "rowgroup"
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "cell",
    "data-cy": "navigation"
  }, /*#__PURE__*/_react.default.createElement(NavItems, {
    role: "list"
  }, items?.map((item, i) => {
    return /*#__PURE__*/_react.default.createElement(NavigationItem, {
      key: i,
      active: toggleState === i + 1,
      handleClick: () => setFilter(i + 1),
      text: item.planType,
      _name: item.planType
    });
  })))));
}
var _default = exports.default = Navigation;
Navigation.propTypes = {
  items: _propTypes.default.array,
  setFilter: _propTypes.default.func,
  disableSticky: _propTypes.default.bool,
  skipOffsetForNav: _propTypes.default.bool,
  toggleState: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};